import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { RecipeV2Detail } from '../types';
import AllergensTab from './AllergensTab';
import DietaryTab from './DietaryTab';

interface AllergensAndDietaryTabProps {
  recipe: RecipeV2Detail;
}

type PanelView = 'allergens' | 'dietary';

/** Combined "Allergens & Dietary" tab (Range Planning demo spec) - toggles between the
 * AllergensTab (allergens/intolerances, with traceability) and DietaryTab (the other four
 * dietary categories) rather than showing both stacked, since they cover different data. */
const AllergensAndDietaryTab = ({ recipe }: AllergensAndDietaryTabProps) => {
  const { t } = useTranslation('recipeV2');
  const [view, setView] = useState<PanelView>('allergens');

  return (
    <Stack spacing={3}>
      <ToggleButtonGroup
        value={view}
        exclusive
        size="small"
        onChange={(_, next: PanelView | null) => next && setView(next)}
      >
        <ToggleButton value="allergens">{t('allergens.title')}</ToggleButton>
        <ToggleButton value="dietary">{t('dietary.title')}</ToggleButton>
      </ToggleButtonGroup>
      {view === 'allergens' ? <AllergensTab recipe={recipe} /> : <DietaryTab recipe={recipe} />}
    </Stack>
  );
};

export default AllergensAndDietaryTab;

